import { render, staticRenderFns } from "./SalesNotification.vue?vue&type=template&id=6a073a89&"
import script from "./SalesNotification.vue?vue&type=script&lang=js&"
export * from "./SalesNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports